import { RefObject, useEffect, useRef } from "react"

export const InsetScrollbar = ({
    scrollRef,
    topInset,
}: {
    scrollRef: RefObject<HTMLElement | null>
    topInset: number
}) => {
    const thumbRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const element = scrollRef.current
        const thumb = thumbRef.current
        if (!element || !thumb) return
        const measure = () => {
            const { scrollTop, scrollHeight, clientHeight } = element
            const overflow = scrollHeight - clientHeight
            thumb.style.display = overflow > 0 ? "" : "none"
            if (overflow <= 0) return
            const track = clientHeight - topInset
            const height = Math.max(24, (clientHeight / scrollHeight) * track)
            thumb.style.height = `${height}px`
            thumb.style.top = `${(scrollTop / overflow) * (track - height) + topInset}px`
        }
        measure()
        element.addEventListener("scroll", measure, { passive: true })
        const observer = new ResizeObserver(measure)
        observer.observe(element)
        for (const child of Array.from(element.children)) observer.observe(child)
        return () => {
            element.removeEventListener("scroll", measure)
            observer.disconnect()
        }
    }, [scrollRef, topInset])

    return (
        <div
            ref={thumbRef}
            style={{ display: "none" }}
            className="absolute right-0.5 w-[5px] rounded-full bg-white-300 hover:bg-white-400 active:bg-white-200 z-20"
            onPointerDown={(event) => {
                event.preventDefault()
                const element = scrollRef.current
                const thumb = thumbRef.current
                if (!element || !thumb) return
                const startY = event.clientY
                const { scrollTop, scrollHeight, clientHeight } = element
                const travel = clientHeight - topInset - thumb.offsetHeight
                document.body.style.userSelect = "none"

                const onMove = (move: PointerEvent) => {
                    element.scrollTop =
                        scrollTop +
                        ((move.clientY - startY) / travel) * (scrollHeight - clientHeight)
                }
                const onUp = () => {
                    document.body.style.userSelect = ""
                    window.removeEventListener("pointermove", onMove)
                    window.removeEventListener("pointerup", onUp)
                }
                window.addEventListener("pointermove", onMove)
                window.addEventListener("pointerup", onUp)
            }}
        />
    )
}
